module.exports = __webpack_public_path__ + "static/1st_floor_4-76962352a50a7f1c345d096a04ca4ea9.jpg";